import type { FC } from "react";
import React, { memo } from "react";
import clsx from "clsx";
import type { GradeBodyTypeType } from "../../../../utils/types/Model";
import List from "../../../../../shared-components/css-modules/lexus/atoms/List";
import styles from "./Item.module.scss";

export const MAX_ITEMS = 3;
const HighlightsView: FC<{
    gradeBodyType: GradeBodyTypeType;
}> = ({ gradeBodyType }) => {
    return (
        <div className={clsx(styles.fade, styles["highlights-view"])}>
            <List variant="checkmarks" sizing="sm" color="primary-black">
                {gradeBodyType.equipment

                    .filter(({ gradeFeature }) => gradeFeature)
                    .slice(0, MAX_ITEMS)
                    .map((equipment) => (
                        <li
                            key={equipment.id}
                            title={equipment.name}
                            className={clsx(styles.fade, styles["checkmark-item"], styles["checkmark-item-large"])}
                        >
                            {equipment.name}
                        </li>
                    ))}
            </List>
        </div>
    );
};

export default memo(HighlightsView);
